import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default abstract class RentalAgreementModel extends Model {
  @attr('string') url!: string;
  @attr('string') s3Url!: string | null;
  @attr('string') filename!: string;

  @belongsTo('property', { inverse: 'rentalAgreement', async: false })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'rental-agreement': RentalAgreementModel;
  }
}
